import { useState } from 'react'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Typography from '@mui/material/Typography'

import { useProductPage } from '~/products/hooks/useProductPage'
import Notes from '~/components/notes/generic-notes'

export default function NotesContainer() {
    const { productInfo } = useProductPage()
    const [isExpanded, setIsExpanded] = useState(false)

    // Guard: hooks may provide a narrowed productInfo in some states.
    const product = (productInfo as any)?.product
    const store = (productInfo as any)?.store
    if (!product || !store) {
        return null
    }

    return (
        <Accordion
            disableGutters
            square
            expanded={isExpanded}
            onChange={(_, expanded) => setIsExpanded(expanded)}
        >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>{gettext('Notes')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Notes
                    objectType="product"
                    objectId={product.id}
                    storeId={store.id}
                />
            </AccordionDetails>
        </Accordion>
    )
}
